import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { parseCookies } from '@cian/utils';
/** @deprecated При отказе от тизер событий поле будет удалено */
export var sendTeaserAdfoxEventFactory = function sendTeaserAdfoxEventFactory(payload) {
  return function (action) {
    var _window;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var page = ((_window = window) === null || _window === void 0 || (_window = _window.CianAnalytics) === null || _window === void 0 || (_window = _window.service) === null || _window === void 0 || (_window = _window.config) === null || _window === void 0 ? void 0 : _window.page) || {
      pageType: undefined,
      siteType: undefined
    };
    var cid = parseCookies(document.cookie)['_CIAN_GK'];
    var teaserApiUrl = getTeaserApiUrl();
    if (!teaserApiUrl) {
      return;
    }
    var name__DEPRECATED = payload.name__DEPRECATED,
      place__DEPRECATED = payload.place__DEPRECATED,
      extra__DEPRECATED = payload.extra__DEPRECATED,
      bannerSource = payload.bannerSource;
    var item = {
      action: action,
      bannerName: "".concat(name__DEPRECATED, "_").concat(action),
      bannerPlace: place__DEPRECATED,
      bannerSource: bannerSource,
      dl: window.location.href,
      timestamp: Date.now()
    };
    if (payload.type === 'withAdfoxData') {
      Object.assign(item, {
        bannerId: payload.id.toString()
      }, payload.jsonFields);
    }
    if (extra__DEPRECATED) {
      Object.assign(item, extra__DEPRECATED);
    }
    fetch(teaserApiUrl, {
      body: JSON.stringify({
        cid: cid,
        device_type: page.siteType,
        items: [item],
        pageType: page.pageType
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
  };
};

/** @deprecated При отказе от тизер событий поле будет удалено */
export var sendTeaserInternalEventFactory = function sendTeaserInternalEventFactory(payload) {
  return function (action) {
    var _window2;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var page = ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.CianAnalytics) === null || _window2 === void 0 || (_window2 = _window2.service) === null || _window2 === void 0 || (_window2 = _window2.config) === null || _window2 === void 0 ? void 0 : _window2.page) || {
      pageType: undefined,
      siteType: undefined
    };
    var cid = parseCookies(document.cookie)['_CIAN_GK'];
    var teaserApiUrl = getTeaserApiUrl();
    if (!teaserApiUrl) {
      return;
    }
    var name = payload.name,
      place = payload.place,
      bannerSource = payload.bannerSource;
    var item = {
      action: action,
      bannerId: payload.id.toString(),
      bannerName: "".concat(name, "_").concat(action),
      bannerPlace: place,
      bannerSource: bannerSource,
      dl: window.location.href,
      timestamp: Date.now()
    };
    fetch(teaserApiUrl, {
      body: JSON.stringify({
        cid: cid,
        device_type: page.siteType,
        items: [item],
        pageType: page.pageType
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
  };
};
function getTeaserApiUrl() {
  var config = getConfig();
  var logger = getLogger();
  var soprExperimentsForTeaserUrl = config.get('soprExperimentsForTeaserUrl');
  if (!soprExperimentsForTeaserUrl) {
    logger.error('soprExperimentsForTeaserUrl is not defined', {
      domain: 'getTeaserApiUrl'
    });
    return null;
  }
  return "".concat(soprExperimentsForTeaserUrl, "teaser/");
}